import React from 'react';
import { Alert, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import ErrorIcon from '@mui/icons-material/Error';

const NotificationToast = ({ notification, onClose }) => {
  const { message, level } = notification;

  // Маппинг уровней на настройки Material-UI
  const getLevelConfig = (level) => {
    switch (level) {
      case 'success':
        return {
          severity: 'success',
          icon: <CheckCircleIcon />,
          color: '#22c55e'
        };
      case 'warning':
        return {
          severity: 'warning',
          icon: <WarningIcon />,
          color: '#f59e0b'
        };
      case 'info':
        return {
          severity: 'info',
          icon: <InfoIcon />,
          color: '#3b82f6'
        };
      case 'error':
        return {
          severity: 'error',
          icon: <ErrorIcon />,
          color: '#ef4444'
        };
      default:
        return {
          severity: 'info',
          icon: <InfoIcon />,
          color: '#3b82f6'
        };
    }
  };

  const config = getLevelConfig(level);

  return (
    <Snackbar
      open={true}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{
        '& .MuiSnackbar-root': {
          bottom: 20,
          right: 20,
        }
      }}
    >
      <Alert
        severity={config.severity}
        icon={config.icon}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{
          minWidth: 320,
          maxWidth: 480,
          borderRadius: 2,
          boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
          '& .MuiAlert-icon': {
            color: config.color,
          },
          '& .MuiAlert-message': {
            color: 'text.primary',
          }
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationToast;
